import React, { useState } from "react";
import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";

const Radioz = ({
  icon,
  value,
  label,
  checked = false,
  onChange,
  className,
}) => {
  const handleClick = () => {
    onChange(checked ? false : value);
  };

  return (
    <>
      <label className={`custom-radio ${className}`} onClick={handleClick}>
        <div
          className={`custom-radio-button ${
            checked ? "checked" : "unchecked"
          } `}
        >
          {checked && <SvgIcn name="ok" className={`check-icon `} />}
        </div>
        <span className={`radio-label ${checked ? "checked" : ""} `}>
          {label}
        </span>
        {icon && (
          <SvgIcn name={icon} className={`icon ${checked ? "checked" : ""} `} />
        )}
      </label>
    </>
  );
};

export default Radioz;
